<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: null
  },
  icon: {
    type: String,
    default: null
  },
  emptyMessage: {
    type: String,
    default: "Nothing's here…",
  },
  headerIcon: {
    type: String,
    default: null
  },
  rounded: {
    type: String,
    default: 'md:rounded'
  },
  hasTable: Boolean,
  empty: Boolean,
  form: Boolean,
  hoverable: Boolean
})

const emit = defineEmits(['headerIconClicked', 'submit'])

const is = computed(() => props.form ? 'form' : 'div')

const componentClass = computed(() => {
  const base = [
    props.rounded
  ]

  if (props.hoverable) {
    base.push('hover:shadow-lg transition-shadow duration-500')
  }

  return base
})

const submit = e => {
  emit('submit', e)
}
</script>

<template>
  <component
    :is="is"
    :class="componentClass"
    class="bg-white border border-indigo-100 shadow-lg shadow-indigo-200 dark:shadow-none dark:bg-gray-900 dark:border-gray-700"
    @submit="submit"
  >
    <header v-if="title" class="flex items-stretch border-b border-indigo-100 dark:border-gray-700">
      <p class="flex items-center py-3 flex-grow font-bold" :class="[ icon ? 'px-4' : 'px-6' ]">
        <base-icon v-if="icon" :path="icon" class="mr-3" />
        {{ title }}
      </p>
    </header>
    <div v-if="empty" class="text-center py-24 text-gray-500 dark:text-gray-400">
      <p>{{ emptyMessage }}</p>
    </div>
    <div v-else :class="{'p-6':!hasTable}">
      <slot />
    </div>
  </component>
</template>
